var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCogsolLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 58.3999C14 30.7857 36.3858 8.3999 64 8.3999C91.6142 8.3999 114 30.7857 114 58.3999C114 86.0141 91.6142 108.4 64 108.4C36.3858 108.4 14 86.0141 14 58.3999Z",
    fill: "#252E3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0285 27.418L48.3757 34.6973V41.6216L62.5794 49.4336M63.6447 28.1282L74.83 35.0524",
    stroke: "#F4F5F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3552 24.3999L79.6242 34.52V46.7707L65.4205 55.4704V62.9273L79.6242 54.7602V63.9926L65.4205 71.8046M61.5145 54.7602L48.7312 47.3033V63.9926L61.5145 71.8046",
    stroke: "#F4F5F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6551 73.2247L63.6447 78.196L79.0911 69.1412V84.4101L63.6447 92.3997L48.3757 83.6999V67.3657",
    stroke: "#F4F5F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCogsolLogo);
export default __webpack_public_path__ + "static/media/cogsol-logo.ce4030ed795b15647eec9b4dbc90d4e2.svg";
export { ForwardRef as ReactComponent };